module.exports = __webpack_public_path__ + "static/media/dockIo.b7dd86c3.png";